import { render, staticRenderFns } from "./DrugInfoManage.vue?vue&type=template&id=c3b04360&"
import script from "./DrugInfoManage.vue?vue&type=script&lang=js&"
export * from "./DrugInfoManage.vue?vue&type=script&lang=js&"
import style0 from "./DrugInfoManage.vue?vue&type=style&index=0&id=c3b04360&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3b04360')) {
      api.createRecord('c3b04360', component.options)
    } else {
      api.reload('c3b04360', component.options)
    }
    module.hot.accept("./DrugInfoManage.vue?vue&type=template&id=c3b04360&", function () {
      api.rerender('c3b04360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/druginfo-manage/DrugInfoManage.vue"
export default component.exports